<div class="buckets-widget-container buckets-widget-header">

  <div class="buckets-header-indicator" [class.has-animation]="leftBucketStatus !== statuses.DEFAULT">
    <div class="bucket-indicator">
      <lib-question-answer-option-code [index]="0"></lib-question-answer-option-code>
      <span class="bucket-count">{{ leftBucketCards?.length }}</span>
    </div>

    @if (leftBucketStatus !== statuses.DEFAULT) {
      <lib-question-answer-validation-indicator
        class="bucket-result-animation"
        [correct]="leftBucketStatus === statuses.CORRECT">
      </lib-question-answer-validation-indicator>
    }

  </div>

  <div class="cards-count-container">
    <div class="cards-count">
      {{ totalCards - remainingCards }} / {{ totalCards }}
    </div>
  </div>

  <div class="buckets-header-indicator" [class.has-animation]="rightBucketStatus !== statuses.DEFAULT">
    <div class="bucket-indicator">
      <lib-question-answer-option-code [index]="1"></lib-question-answer-option-code>
      <span class="bucket-count">{{ rightBucketCards?.length }}</span>
    </div>

    @if (rightBucketStatus !== statuses.DEFAULT) {
      <lib-question-answer-validation-indicator
        class="bucket-result-animation"
        [correct]="rightBucketStatus === statuses.CORRECT">
      </lib-question-answer-validation-indicator>
    }
  </div>

</div>


<div class="buckets-widget-container drop-list-group-widget" cdkDropListGroup>
  <div class="animate__animated bucket-container" [ngClass]="animationOptions.enabled && animationOptions.animation" [style.animationDelay.ms]="animationOptions.delay + 200">
    <div class="bucket status-{{leftBucketStatus}}" cdkDropList [cdkDropListData]="leftBucketCards" (cdkDropListDropped)="drop($event)">

      <ng-container
      *ngTemplateOutlet="bucketCardsTmp; context: { data: leftBucketCards, bucket: buckets?.[0], code: 0 }"></ng-container>

      <div class="bucket-placeholder"></div>
    </div>
    @if (showEditButton) {
      <div class="card-actions">
        <button
          mat-icon-button
          class="button button--icon button--icon-extra-small button--black"
          (click)="onBucketEdit(0)">
          <lib-icon icon="pencil-simple"></lib-icon>
        </button>
      </div>
    }
  </div>

  <div class="animate__animated cards-container" [ngClass]="animationOptions.enabled && animationOptions.animation" [style.animationDelay.ms]="animationOptions.delay + 400">

    @if (cardsArray.length) {
      <div class="cards-arrow-indicator">
        <lib-icon icon="caret-left" class="left-icon"></lib-icon>
        <hr class="line">
        <lib-icon icon="caret-right" class="right-icon"></lib-icon>
      </div>
    }

    <div class="cards" cdkDropList [cdkDropListData]="cardsArray" [cdkDropListDisabled]="showEditButton">

      @for (card of cardsArray; track trackByFn(i, card); let i = $index) {
        <lib-bucket-card
          class="bucket-card"
          cdkDrag
          [card]="card"
          [spacing]="spacing"
          [showErrors]="showErrors"
          [cardsCount]="cardsArray?.length"
          [slide]="slide"
          [showEditButton]="showEditButton"
          [isTranslation]="isTranslation"
          (edit)="emitEdit(i)"
          (remove)="emitRemove(i)">
          <ng-template cdkDragPlaceholder></ng-template>
        </lib-bucket-card>
      }

      @if (cardsArray.length === 0) {
        <div class="cards-completed">
          <lib-icon icon="check-circle" class="cards-completed-icon"></lib-icon>
          <span class="cards-completed-text">
            {{ 'SLIDES.well_done_buckets_cards_used' | translate }}
          </span>
        </div>
      }

    </div>
  </div>

  <div class="animate__animated bucket-container" [ngClass]="animationOptions.enabled && animationOptions.animation" [style.animationDelay.ms]="animationOptions.delay + 600">
    <div class="bucket status-{{rightBucketStatus}}" cdkDropList [cdkDropListData]="rightBucketCards" (cdkDropListDropped)="drop($event)">
      <ng-container
      *ngTemplateOutlet="bucketCardsTmp; context: { data: rightBucketCards, bucket: buckets?.[1], code: 1 }"></ng-container>

      <div class="bucket-placeholder"></div>
    </div>
    @if (showEditButton) {
      <div class="card-actions">
        <button
          mat-icon-button
          class="button button--icon button--icon-extra-small button--black"
          (click)="onBucketEdit(1)">
          <lib-icon icon="pencil-simple"></lib-icon>
        </button>
      </div>
    }
  </div>
</div>

<div class="mobile-buckets-info">
  <div class="bucket-title" [class.active]="leftBucketCards?.length" [class.has-error]="showErrors && !buckets?.[0]?.title" (click)="moveCardToBucket(leftBucketCards)">
    <lib-question-answer-option-code [index]="0"></lib-question-answer-option-code>
    <span class="bucket-text" [autoTextDirection]="isTranslation" [autoTextDirectionValue]="buckets?.[0]?.title">
      {{ buckets?.[0]?.title }}
    </span>
  </div>

  <div class="bucket-title" [class.active]="rightBucketCards?.length" [class.has-error]="showErrors && !buckets?.[1]?.title" (click)="moveCardToBucket(rightBucketCards)">
    <lib-question-answer-option-code [index]="1"></lib-question-answer-option-code>
    <span class="bucket-text" [autoTextDirection]="isTranslation" [autoTextDirectionValue]="buckets?.[1]?.title">
      {{ buckets?.[1]?.title }}
    </span>
  </div>
</div>

<ng-template #bucketCardsTmp let-data="data" let-bucket="bucket" let-code="code">
  <div class="bucket-content" (click)="moveCardToBucket(data)">

    <div class="bucket-title" [class.has-error]="showErrors && !bucket.title">
      <lib-question-answer-option-code [index]="code"></lib-question-answer-option-code>
      <span class="bucket-text" [autoTextDirection]="isTranslation" [autoTextDirectionValue]="bucket.title">
        {{ bucket.title }}
      </span>
    </div>
  </div>
</ng-template>